module.exports = __webpack_public_path__ + "media/images/icons/country_flags/lu-5b52430a07e21655ba90e3bed0f1c818.svg";